<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-center`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.09277C8.45831 2.09277 8.82995 2.46457 8.83008 2.92285V7.16992H11.1699V4.19531C11.1699 3.73693 11.5416 3.36523 12 3.36523C12.4584 3.36523 12.8301 3.73693 12.8301 4.19531V7.16992H14C14.4584 7.16992 14.8301 7.5416 14.8301 8C14.8301 8.4584 14.4584 8.83008 14 8.83008H12.8301V11.8047C12.8301 12.2631 12.4584 12.6348 12 12.6348C11.5416 12.6348 11.1699 12.2631 11.1699 11.8047V8.83008H8.83008V13.0771C8.83001 13.5355 8.45836 13.9072 8 13.9072C7.54164 13.9072 7.16999 13.5355 7.16992 13.0771V8.83008H4.83008V10.8506C4.83 11.3089 4.45835 11.6807 4 11.6807C3.54165 11.6807 3.17 11.3089 3.16992 10.8506V8.83008H2C1.54174 8.82991 1.16992 8.45829 1.16992 8C1.16992 7.54171 1.54174 7.17009 2 7.16992H3.16992V5.14941C3.1701 4.69117 3.54171 4.31934 4 4.31934C4.45829 4.31934 4.8299 4.69117 4.83008 5.14941V7.16992H7.16992V2.92285C7.17005 2.46457 7.54169 2.09277 8 2.09277Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignCenter',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
